<script>
export default {
  name: 'Modal',
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
<template>
  <transition name="modal-fade">
    <div class="mportal-modal-backdrop">
      <div
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
        class="mportal-modal mportal-max-h-screen mportal-inline-block mportal-align-bottom mportal-bg-white mportal-overflow-y-auto mportal-rounded-lg mportal-px-4 mportal-pt-5 mportal-pb-4 mportal-text-left mportal-shadow-xl mportal-transform mportal-transition-all sm:mportal-my-8 sm:mportal-align-middle sm:mportal-max-w-7xl sm:mportal-w-full sm:mportal-p-6 m-4"
      >
        <header
          id="modalTitle"
          class="mportal-modal-header mportal-py-8"
        >
          <slot name="header" />
          <button
            type="button"
            class="mportal-btn-close"
            aria-label="Close modal"
            @click="close"
          >
            x
          </button>
        </header>
        <section
          id="modalDescription"
          class="mportal-modal-body pmportal-y-5"
        >
          <slot name="body" />
        </section>
        <footer class="mportal-modal-footer mportal-pt-5">
          <slot name="footer" />
          <!--
          <button
            type="button"
            class="mt-5 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            aria-label="Close modal"
            @click="close"
          >
            Schließen
          </button>
          -->
        </footer>
      </div>
    </div>
  </transition>
</template>
<style>
.mportal-modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}
.mportal-modal-header,
.mportal-modal-footer {
    display: flex;
}
.mportal-modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    justify-content: space-between;
}
.mportal-modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
}
.mportal-modal-body {
    position: relative;
}
.mportal-btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    background: transparent;
}
.mportal-modal-fade-enter,
.mportal-modal-fade-leave-to {
    opacity: 0;
}
.mportal-modal-fade-enter-active,
.mportal-modal-fade-leave-active {
    transition: opacity .5s ease;
}
</style>

